import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [ready, setReady] = useState(false);
  const [subscription, setSubscription] = useState(null);

  const loadSubscription = async () => {
    try {
      const { data } = await api.get("/subscription/me");
      setSubscription(data);
      return data;
    } catch (e) {
      const fallback = { has_access: false, status: "none", plan: null };
      setSubscription(fallback);
      return fallback;
    }
  };

  useEffect(() => {
    const publicOnly = /^\/(demo|share)(\/|$)/.test(window.location.pathname);
    if (publicOnly) { setUser(false); setReady(true); return; }
    api
      .get("/auth/me")
      .then(async (r) => {
        setUser(r.data);
        await loadSubscription();
      })
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadSubscription();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    await loadSubscription();
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) { console.debug("logout request failed:", e?.message); }
    setUser(false);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, ready, subscription, login, register, logout, setUser, refreshSubscription: loadSubscription }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiErrorDetail };
